.b6{position:absolute;}